import React, { useState, useEffect } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { syncPurchaseState, refreshTxnInspection, runAutoCalc, setIsCompleteAuctionModalOpen, appNotify, setConfirmationModalState } from 'store/actions';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import {
  Paper,
  Typography,
  Button,
  Tooltip,
  Chip,
  SvgIcon,
  IconButton,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions
} from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import TextDivider from 'components/underwrite/acquisition/propertyUnderwrite/header/TextDivider';
import {
  Refresh as RefreshIcon
} from '@material-ui/icons';
import EditIcon from '@material-ui/icons/Edit';
import { ButtonDropdown } from 'components/layout';
import ChipDropdown from 'components/underwrite/acquisition/auctionUnderwrite/header/ChipDropdown';
import { Constants } from 'utilities/constants';
import { sendClientLog } from 'services/logService';
import {
  uwTasksSelector,
  driveByInspectionsSelector,
  auctionTitlesSelector
} from 'store/selectors';
import { format, isSameDay } from 'date-fns';
import { KeyboardDatePicker } from '@material-ui/pickers';
import UpdateAuctionDateByPortfolioId from 'api/revue/auctionPortfolio';
import ClearIcon from '@material-ui/icons/Clear';

const styles = theme => ({
  headerContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    borderRadius: 0,
    height: '100%',
    borderBottom: '1px solid #ddd'
  },
  title: {
    display: 'flex',
    alignItems: 'center',
    marginTop: 4
  },
  subHeader: {
    display: 'flex',
    alignItems: 'center'
  },
  infoSection: {
    display: 'flex',
    height: '100%',
    flexDirection: 'column',
    // justifyContent: 'space-evenly',
    alignItems: 'flex-start',
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2)
  },
  bannerSection: {
    display: 'flex',
    height: '100%',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  propCountValue: {
    marginLeft: theme.spacing(0.5)
  },
  btnGroup: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  btn: {
    // color: 'white',
    marginLeft: '10px',
    marginRight: '10px'
  },
  btnIcon: {
    width: '20px',
    height: '20px'
  },
  btnText: {
    marginLeft: '3px'
  },
  completeLabel: {
    alignSelf: 'center',
    marginRight: '20px',
    backgroundColor: '#67c12e',
    color: 'white',
    fontSize: '16px',
    padding: '5px'
  },
  refreshButton: {
    marginLeft: 4
  },
  closeButton: {
    position: 'absolute',
    right: 0,
    top: 0,
    backgroundColor: '#ffffff'
  },
});

const AuctionUWHeader = ({ classes, selectedTask, selectedAuctionTxnOpps, isUserOwnedTask, refreshTxnInspection, syncPurchaseState,
  runAutoCalc, setIsCompleteAuctionModalOpen, appNotify, setConfirmationModalState }) => {
  const [totalUWTasks, remainingUWTasks, completedUWTasks] = uwTasksSelector(selectedAuctionTxnOpps);
  const [totalDriveByInspections, remainingDriveByInspections, completedDriveByInspections] = driveByInspectionsSelector(selectedAuctionTxnOpps);
  const [totalTitles, remainingTitles, importedTitles] = auctionTitlesSelector(selectedAuctionTxnOpps);
  const [auctionDate, setAuctionDate] = useState(null);
  const [auctionDateError, setAuctionDateError] = useState('');
  const [txnOppIdsNeedRecalc, setTxnOppIdsNeedRecalc] = useState([]);
  const [auctionDateModalOpen, setAuctionDateModalOpen] = useState(false);
  const [auctionTxnOppsIsCompleted, setAuctionTxnOppsIsCompleted] = useState(false);

  useEffect(() => {
    if (selectedAuctionTxnOpps?.length > 0) {
      let checkTxnOppsIsCompleted = selectedAuctionTxnOpps.some(txnOpp => !(txnOpp.opportunityStatus === Constants.OpportunityStatus.COMPLETED || txnOpp.opportunityStatus === Constants.OpportunityStatus.TERMINATED));
      setAuctionTxnOppsIsCompleted(!checkTxnOppsIsCompleted);
    }
  }, [selectedAuctionTxnOpps]);

  const handleAuctionRefresh = () => {
    sendClientLog('Info', 'Auction UW - User clicked Auction refresh button');
  }

  const handleSync = (item) => {
    switch (item.value) {
      case 'inspection':
        handleSyncInspection();
        break;
      case 'icbm':
        console.log('sync icbm');
        break;
      case 'purchase state':
        handleSyncPurchaseState();
        break;
      case 'all':
        console.log('sync all');
        break;
      default:
        console.log('sync NOTHING');
        break;
    }
  }

  const handleSyncInspection = () => {
    setConfirmationModalState({
      isModalOpen: true,
      handleConfirmation: handleSyncInspectionConfirmation,
      handleCancellation: closeConfirmationModal,
      titleText: 'Confirm',
      contentText: `Are you sure you want to sync inspections for all transaction opportunities?`
    });
  }
  const handleSyncInspectionConfirmation = () => {
    closeConfirmationModal();
    refreshTxnInspection(selectedAuctionTxnOpps.map(opp => opp.id));
  }

  const handleSyncPurchaseState = () => {
    setConfirmationModalState({
      isModalOpen: true,
      handleConfirmation: handleSyncPurchaseStateConfirmation,
      handleCancellation: closeConfirmationModal,
      titleText: 'Confirm',
      contentText: `Are you sure you want to sync purchase state for all transaction opportunities?`
    });
  }
  const handleSyncPurchaseStateConfirmation = () => {
    closeConfirmationModal();
    syncPurchaseState(selectedAuctionTxnOpps.map(opp => opp.id))
  }

  const handleCalculateWithRepairs = () => {
    const txnOppsToRunCalculate = selectedAuctionTxnOpps;
    if (txnOppsToRunCalculate.length > 0) {
      setConfirmationModalState({
        isModalOpen: true,
        handleConfirmation: () => handleCalculateWithRepairsConfirmation(txnOppsToRunCalculate),
        handleCancellation: closeConfirmationModal,
        titleText: 'Confirm',
        contentText: `Are you sure you want to calculate ${txnOppsToRunCalculate.length} ${txnOppsToRunCalculate.length > 1 ? 'valuations' : 'valuation'} with inspection repairs?`
      });
    }
    else {
      appNotify('No eligible txnOpps for calculation', 'warning');
    }
  }
  const handleCalculateWithRepairsConfirmation = (txnOppsToRunCalculate) => {
    closeConfirmationModal();
    runAutoCalc(txnOppsToRunCalculate.map(opp => opp.id));
  }

  const closeConfirmationModal = () => {
    setConfirmationModalState({ isModalOpen: false });
  }

  const handleCompleteAuction = () => {
    setIsCompleteAuctionModalOpen(true);
  };

  const handleShowMe = () => {
    console.log(txnOppIdsNeedRecalc);
  }
  const closeAuctionDateModal = (e, reason) => {
    if (reason === 'backdropClick') return; // updated handling for disableBackdropClick
    setAuctionDateModalOpen(false);
  }
  const openAuctionDateModal = () => {
    setAuctionDateModalOpen(true);
  }
  const handleAuctionDateSubmit = async () => {
    let auctionUpdateResponse = await UpdateAuctionDateByPortfolioId(selectedTask.id, auctionDate);
    if (auctionUpdateResponse.success) {
      appNotify(`Auction Date changed successfully to ${format(new Date(auctionDate), 'MM/dd/yyyy')}, please refresh the workflow grid`, 'success');
      closeAuctionDateModal();
    } else {
      appNotify(auctionUpdateResponse.errorMessage, 'warning');
      closeAuctionDateModal();
    }
  }

  let formattedAuctionDate = selectedTask && selectedTask.auctionDate && format(new Date(selectedTask.auctionDate), 'MM/dd/yyyy');
  return (
    <Paper className={classes.headerContainer} elevation={0}>
      <Dialog open={auctionDateModalOpen} onClose={closeAuctionDateModal}>
        <DialogTitle>
          Change Auction Date
        </DialogTitle>
        <IconButton className={classes.closeButton} onClick={closeAuctionDateModal}>
          <ClearIcon fontSize="inherit" />
        </IconButton>
        <DialogContent>
          <KeyboardDatePicker
            placeholder={formattedAuctionDate}
            value={auctionDate || selectedTask.auctionDate}
            onChange={date => setAuctionDate(date)}
            format="MM/dd/yyyy"
            openTo="date"
            minDate={new Date()}
            onError={(error) => setAuctionDateError(error)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={closeAuctionDateModal}>Cancel</Button>
          <Button onClick={handleAuctionDateSubmit} variant="contained" color="primary"
            disabled={
              auctionDate == null ||
              auctionDateError !== '' ||
              isSameDay(new Date(selectedTask.auctionDate), auctionDate) // TODO: check if this is affected by timezone issue (ie auctionDate is in central time because of server location, but startOfToday will return UTC time with timezone based on user location)
            }>
            Submit
          </Button>
        </DialogActions>
      </Dialog>
      <div className={classes.infoSection}>
        <div className={classes.title}>
          <Typography variant="h5" align="left">
            {selectedTask.portfolioName + (selectedAuctionTxnOpps[0] ? " (" + selectedAuctionTxnOpps[0].importName + ")" : "")}
          </Typography>
          {selectedTask.completedOn == null &&
            <Tooltip title="Change Auction Date">
              <IconButton onClick={openAuctionDateModal} className={classes.refreshButton}>
                <EditIcon />
              </IconButton>
            </Tooltip>
          }
          <ChipDropdown
            selectedTask={selectedTask}
          />
          <Tooltip title='Refresh auction data'>
            <IconButton onClick={handleAuctionRefresh} className={classes.refreshButton}>
              <RefreshIcon />
            </IconButton>
          </Tooltip>
        </div>
        <div className={classes.subHeader}>
          <Typography variant="subtitle2">Rent UW:</Typography>
          <Typography className={classes.propCountValue}>
            {remainingUWTasks} remaining ({completedUWTasks}/{totalUWTasks})
          </Typography>
          <TextDivider />
          <Typography variant="subtitle2">Drive By Insp:</Typography>
          <Typography className={classes.propCountValue}>
            {remainingDriveByInspections} remaining ({completedDriveByInspections}/{totalDriveByInspections})
          </Typography>
          <TextDivider />
          <Typography variant="subtitle2">Title:</Typography>
          <Typography className={classes.propCountValue}>
            {remainingTitles} remaining ({importedTitles}/{totalTitles})
          </Typography>
        </div>
      </div>

      {txnOppIdsNeedRecalc?.length > 0 ?
        <div className={classes.bannerSection}>
          <Alert elevation={6}
            variant="filled"
            severity="info"
            action={<Button variant="outlined" color="inherit" size="small" onClick={handleShowMe}>Show Me</Button>}>
            {txnOppIdsNeedRecalc.length} txn opps have better icbm orders
          </Alert>
        </div>
        : null
      }

      {selectedAuctionTxnOpps && selectedAuctionTxnOpps[0] && selectedAuctionTxnOpps[0].isAuctionCompleted ?
        (<Chip
          label={'Completed'}
          className={classes.completeLabel}
        />) :
        (<div className={classes.btnGroup}>
          <ButtonDropdown
            title='Sync Data'
            // width={150}
            className={classes.btn}
            onSelect={handleSync}
            items={[{ text: 'Inspection', value: 'inspection' }, { text: 'Purchase state', value: 'purchase state' }]}
          />
          {/* { text: 'ICBM', value: 'icbm' },, { text: 'All', value: 'all' } */}
          <Tooltip title="Calculate valuations with inspection repairs" aria-label="Calculate valuations with inspection repairs" >
            <div>
              <Button variant="contained" color="primary" className={classes.btn} onClick={handleCalculateWithRepairs} disabled={!isUserOwnedTask}>
                <SvgIcon className={classes.btnIcon}>
                  <path fill="#ffffff" d="M7,2H17A2,2 0 0,1 19,4V20A2,2 0 0,1 17,22H7A2,2 0 0,1 5,20V4A2,2 0 0,1 7,2M7,4V8H17V4H7M7,10V12H9V10H7M11,10V12H13V10H11M15,10V12H17V10H15M7,14V16H9V14H7M11,14V16H13V14H11M15,14V16H17V14H15M7,18V20H9V18H7M11,18V20H13V18H11M15,18V20H17V18H15Z" />
                </SvgIcon>
                <span className={classes.btnText}>Calc With Repairs</span>
              </Button>
            </div>
          </Tooltip>
          <Tooltip title="Complete Auction" aria-label="Complete Auction" >
            <div>
              <Button variant="contained" color="primary" className={classes.btn} onClick={handleCompleteAuction} disabled={!isUserOwnedTask || !auctionTxnOppsIsCompleted}>Complete</Button>
            </div>
          </Tooltip>
        </div>)}
    </Paper>
  );
};

const mapState = (state) => ({
  user: state.appState.user
});

const mapDispatch = (dispatch) => (
  {
    runAutoCalc: (txnOppIds) => dispatch(runAutoCalc(txnOppIds)),
    refreshTxnInspection: (txnOppIds) => dispatch(refreshTxnInspection(txnOppIds)),
    syncPurchaseState: (txnOppIds) => dispatch(syncPurchaseState(txnOppIds)),
    setIsCompleteAuctionModalOpen: (isOpen) => dispatch(setIsCompleteAuctionModalOpen(isOpen)),
    appNotify: (message, variant, options) => dispatch(appNotify(message, variant, options)),
    setConfirmationModalState: confirmationModalState => dispatch(setConfirmationModalState(confirmationModalState))
  }
);

export default compose(withStyles(styles), connect(mapState, mapDispatch))(AuctionUWHeader);


